import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

export type BulkColumnInput = {
  label: string;
  name: string;
  type: string;
  optional?: boolean;
};

@Component({
  selector: 'app-schema-columns-json-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule
  ],
  templateUrl: './schema-columns-json-dialog.component.html',
  styleUrl: './schema-columns-json-dialog.component.scss'
})
export class SchemaColumnsJsonDialogComponent {
  jsonText = '';

  constructor(
    private dialogRef: MatDialogRef<SchemaColumnsJsonDialogComponent>,
    private snackBar: MatSnackBar
  ) {}

  close(): void {
    this.dialogRef.close();
  }


  apply(): void {
    const raw = this.jsonText.trim();
    if (!raw) {
      this.snackBar.open('Pega un JSON válido para crear columnas.', 'Cerrar', {
        duration: 3500
      });
      return;
    }

    let parsed: unknown;
    try {
      parsed = JSON.parse(raw);
    } catch {
      this.snackBar.open('El JSON no tiene un formato válido.', 'Cerrar', {
        duration: 4000
      });
      return;
    }

    if (!Array.isArray(parsed)) {
      this.snackBar.open('El JSON debe ser un arreglo de columnas.', 'Cerrar', {
        duration: 4000
      });
      return;
    }

    const normalized: BulkColumnInput[] = [];
    for (const item of parsed) {
      const row = item as Record<string, unknown>;
      const label = String(row['label'] ?? '').trim();
      const name = String(row['name'] ?? '').trim();
      const type = String(row['type'] ?? '').trim();

      if (!label || !name || !type) {
        this.snackBar.open('Cada item debe tener: label, name y type.', 'Cerrar', {
          duration: 4500
        });
        return;
      }

      normalized.push({
        label,
        name,
        type,
        optional: row['optional'] === true
      });
    }

    this.dialogRef.close(normalized);
  }
}
